import React, { useState } from 'react';
import axios from 'axios';
import { SignalIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import './theme.css';

const API_BASE = '/api';

function LoginPage({ setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const login = async () => {
    try {
      const res = await axios.post(`${API_BASE}/login`, { email, password });
      const token = res.data.access_token;
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUser({ token, role: payload.role });
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--ink-950)] text-[var(--text-primary)] font-[var(--font-ui)] px-4">
      <div className="w-full max-w-md bg-[var(--surface-900)] rounded-xl border border-[var(--surface-800)] shadow-lg p-8">
        <h2 className="text-3xl font-bold text-center flex items-center justify-center gap-2 mb-2">
          Signetry <SignalIcon className="w-5 h-5 text-[var(--text-muted)]" />
        </h2>
        <p className="text-sm text-center text-[var(--text-muted)] mb-6">Tactical Wireless Intelligence</p>

        {error && (
          <p className="text-[var(--status-error)] text-sm mb-4 text-center">{error}</p>
        )}

        <input
          type="email"
          placeholder="Email"
          className="w-full mb-4 px-4 py-3 bg-[var(--ink-950)] border border-[var(--surface-800)] rounded-md text-sm text-[var(--text-primary)] placeholder-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--signal-cyan)]"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="w-full mb-6 px-4 py-3 bg-[var(--ink-950)] border border-[var(--surface-800)] rounded-md text-sm text-[var(--text-primary)] placeholder-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--signal-cyan)]"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={login}
          className="w-full text-[var(--signal-cyan)] border border-[var(--signal-cyan)] font-semibold py-2 px-4 rounded-md hover:bg-[var(--surface-800)] transition"
        >
          Sign In
        </button>
      </div>
    </div>
  );
}

export default LoginPage;